import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Translation } from '@/hoslog-intl';
import { GalleryIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/store-information/premium-stores/gallery/$store-gallery')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: <CrumbTitle id="storeManagement.galleryManagement.crumb" icon={GalleryIcon} />,
      title: <Translation id="storeManagement.galleryManagement.crumb" />,
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
